export default __webpack_public_path__ + "static/media/Val Pires_.44fce293.png";